import React, { useEffect, useState } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import './Compliance.scss';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useHistory } from 'react-router-dom';
import { RenderComplianceTopHeader } from './CommonComplianceComponents';
import { useSelector, useDispatch } from 'react-redux';
import { SET_SELECTED_SITE, GET_COMPLIANCE_STATE_DATA, GET_COMPLIANCE_INITIAL_DATA, SET_PROCESSED_DATA } from './complianceConstants';
import Page_Loader from "../../assets/vizr_images/page_loader.gif";
import { processComplianceDataUtils } from './ComplianceUtils';
import { renderCompliantIcon, renderCIAIcon, Accordion } from './CommonComplianceComponents';

const Compliance = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const complianceData = useSelector(
    (state) => state.ComplianceReducer.complianceStateData?.standardRules
  );
  const initialData = useSelector(
    (state) => state.ComplianceReducer.complianceInitialData
  );
  const complianceLoader = useSelector(
    (state) => state.ComplianceReducer.complianceLoader
  );
  const selectedSiteFromStore = useSelector(
    (state) => state.ComplianceReducer.selectedSite
  );
  const pieChartData = useSelector(
    (state) => state.ComplianceReducer.processedData
  );
  const stateList = useSelector(
    (state) => state.ComplianceReducer.stateList
  );
  const [data, setData] = useState(complianceData);
  useEffect(() => {
    dispatch({ type: GET_COMPLIANCE_INITIAL_DATA });
  }, []);
  useEffect(() => {
    if (stateList.length > 0 && (selectedSiteFromStore === null || !selectedSiteFromStore.name)) {
      const firstState = stateList[0];
      dispatch({ type: SET_SELECTED_SITE, payload: { selectedSite: { name: firstState } } });
    }
  }, [stateList]);
  useEffect(() => {
    dispatch({ type: GET_COMPLIANCE_STATE_DATA, payload: { selectedSite: selectedSiteFromStore } });
  }, [selectedSiteFromStore, initialData]);
  useEffect(() => {
    if (complianceData && complianceData.length !== 0) {
      const { processedData, headerData } = processComplianceDataUtils(complianceData);
      dispatch({ type: SET_PROCESSED_DATA, payload: { processedData: processedData } });
    }
    setData(complianceData);
  }, [complianceData]);

  const setExpanded = (isExpanded, id) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, expanded: isExpanded } : item
      )
    );
  };

  const navigateToDashboard = () => {
    history.push("/gov/compliancedashboard");
  };

  const renderComplianceView = () => {
    return (
      <>
        <div className="cp-main-container">
          <div className="navigationParentContainer">
            <div
              className="navigationIconContainer"
              onClick={navigateToDashboard}
            >
              <ArrowBackIosIcon className="icon" />
              <div className="navigationText">Back</div>
            </div>
          </div>
          {data && pieChartData && <Paper
            className="cp-container"
            sx={{ width: "100%", overflow: "hidden", marginTop: 1 }}
            elevation={0}
          >
            <span className="page-header">Status Overview</span>
            <div className="float-right">
              Confidentiality (C) | Integrity (I) | Availability (A)
            </div>
            <TableContainer sx={{ maxHeight: 500 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow className="tbl-header">
                    <TableCell className="cell-width">Control Name</TableCell>
                    <TableCell className="cell-width"></TableCell>
                    <TableCell className="cell-width"></TableCell>
                    <TableCell className="cell-width"></TableCell>
                    <TableCell className="cell-width" align="center">
                      Compliance Status
                    </TableCell>
                    <TableCell className="cell-width" align="center">
                      Remarks
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((item) => {
                    const chartData = pieChartData.find(
                      (chart) => chart.id === item.id
                    );
                    const yesObj =
                      chartData?.pieChartData?.[0]?.data?.find(
                        (data) => data.type === "Yes"
                      ) || null;
                      return (
                        <TableRow key={item.id}>
                          <TableCell colSpan="6" className="pad-0">
                            <Accordion
                              isExpanded={item.expanded}
                              onChange={(e, isExpanded) =>
                                setExpanded(isExpanded, item.id)
                              }
                              item={item}
                              yesObj={yesObj}
                            >
                              <Table className="tbl-data-container">
                                {item.sections?.map((section) => {
                                  let lastUpdatedDate = '';
                                  if (section.lastUpdatedTimestamp) {
                                      const date = new Date(Number(section.lastUpdatedTimestamp));
                                      const mm = String(date.getMonth() + 1).padStart(2, '0');
                                      const dd = String(date.getDate()).padStart(2, '0');
                                      const yyyy = date.getFullYear();
                                      const hh = String(date.getHours()).padStart(2, '0');
                                      const min = String(date.getMinutes()).padStart(2, '0');
                                      lastUpdatedDate = `${mm}-${dd}-${yyyy} ${hh}:${min}`;
                                  } else {
                                    lastUpdatedDate = "N/A";
                                  }
                                  return (
                                  <TableRow
                                    key={section.sectionDescription}
                                    className="tbl-data-row"
                                  >
                                    <TableCell className="cell-width">
                                      {section.sectionDescription}
                                    </TableCell>
                                    <TableCell
                                      className="cell-width"
                                      align="center"
                                    >
                                      {renderCIAIcon(section["c"])}
                                    </TableCell>
                                    <TableCell
                                      className="cell-width"
                                      align="center"
                                    >
                                      {renderCIAIcon(section["i"])}
                                    </TableCell>
                                    <TableCell
                                      className="cell-width"
                                      align="center"
                                    >
                                      {renderCIAIcon(section["a"])}
                                    </TableCell>
                                    <TableCell
                                      className="cell-width"
                                      align="center"
                                    >
                                      {renderCompliantIcon(
                                        section.compliant,
                                        section.remark
                                      )}
                                    </TableCell>
                                    <TableCell className="cell-width font-italic pad35">
                                      Last updated Time: {lastUpdatedDate}<br />
                                      Status Changed from {section.lastKnownState ? section.lastKnownState : "Unknown"} to {section.currentState}<br />
                                      Reason: {section.remark}
                                    </TableCell>
                                  </TableRow>
                                )})}
                              </Table>
                            </Accordion>
                          </TableCell>
                        </TableRow>
                      );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>}
        </div>
      </>
    );
  }

  return (
    <>
      <RenderComplianceTopHeader
        title="Compliance Maturity Report"
        subtitle=""
      />
      {(complianceLoader) ? (
        <div className="loader-container">
          <img src={Page_Loader} alt="Loading..." />
        </div>
      ) : renderComplianceView()}
    </>
  );
}

export default Compliance;